import { useState, useMemo, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, useLocation } from 'react-router-dom';
import './WebApp/Components/globalVariables.js';
import { useGeofenceNotifications } from './WebApp/Hooks/useGeofenceNotifications.js';
import LoginPage from './WebApp/Pages/Login/login.tsx';
import Trips from './WebApp/Pages/Trips/trips.tsx';
import Dashboard from './WebApp/Pages/Dashboard/dashboard.tsx';
import Devices from './WebApp/Pages/Devices/devices.tsx';
import Vehicles from './WebApp/Pages/Vehicles/vehicle.tsx';
import Drivers from './WebApp/Pages/Drivers/drivers.tsx';
import Institutions from './WebApp/Pages/Institutions/institutions.tsx';
import Billing from './WebApp/Pages/Billing/billing.tsx';
import Reports from './WebApp/Pages/Reports/reports.tsx';
import DocumentsScreen from './WebView/Pages/Documents/documents.tsx';
import RegisterScreen from './WebView/Pages/Register/register.tsx';
// import Parents from './WebApp/Pages/Parents/parents.tsx';
import LoginScreen from './WebView/Pages/Login/login.tsx';
import OffersScreen from './WebView/Pages/Offers/offers.tsx';
import OrdersScreen from './WebView/Pages/Orders/orders.tsx';
import RoutesScreen from './WebView/Pages/Routes/routes.tsx';
import QRCodePaymentScreen from './WebView/Pages/Orders/qr-payment.tsx';
import OrderSummaryScreen from './WebView/Pages/Orders/order-summary.tsx';
import RoutePage from './WebView/Pages/Orders/route.tsx';
import TripsScreen from './WebView/Pages/Trips/trips.tsx';
import DashboardScreen from './WebView/Pages/Dashboard/dashboard.tsx';
import ShowMoreTrips from './WebView/Pages/Trips/show_more_trips.tsx';
import Company from './WebApp/Pages/Company/company.tsx';
import ClientsPage from './WebApp/Pages/Clients/clients.tsx';
import VendorsPage from './WebApp/Pages/Vendors/vendors.tsx';
import WarehousesPage from './WebApp/Pages/Warehouses/warehouse.tsx';
import UsersPage from './WebApp/Pages/Users/user.tsx';
import OrdersPage from './WebApp/Pages/Orders/orders.tsx';
import Offers from './WebApp/Pages/Offers/offers.tsx';
import Earnings from './WebApp/Pages/Earnings/earnings.tsx';
import PrivacyPolicy from './WebApp/Pages/Login/privacy_policy.tsx';
import WebViewPrivacyPolicy from './WebView/Pages/Login/privacy_policy.tsx';
import TermsOfService from './WebApp/Pages/Login/terms_of_service.tsx';
import WebViewTermsOfService from './WebView/Pages/Login/terms_of_service.tsx';
import TripDirections from './WebApp/Pages/Trips/trip-directions.tsx';
import ParentsPage from './WebView/Pages/Parents/parents.tsx';
import StopsPage from './WebView/Pages/Stops/stops.tsx';
import Stops from './WebApp/Pages/Stops/stops.tsx';
import TicketPage from './WebApp/Pages/Tickets/tickets.tsx';

function App() {
  const location = useLocation();
  const [isCheckingPermission, setIsCheckingPermission] = useState(true);

  const { storedUser, token } = useMemo(() => {
    const userStr = localStorage.getItem("userdetails");
    const parsedUser = userStr ? JSON.parse(userStr) : null;
    
    return {
      storedUser: parsedUser,
      token: parsedUser?.token || null
    };
  }, [location.pathname]);

  const { notificationPermission, requestPermission } = useGeofenceNotifications(storedUser, token);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsCheckingPermission(false);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  const shouldShowNotificationBanner =
    storedUser &&
    !isCheckingPermission &&
    notificationPermission === 'default' &&
    localStorage.getItem('notificationBannerDismissed') !== 'true';

  return (
    <div className="App">
      {shouldShowNotificationBanner && (
        <div style={{ 
          background: '#007bff', color: 'white', padding: '10px', 
          textAlign: 'center', zIndex: 9999, position: 'relative' 
        }}>
          Enable browser notifications to receive background alerts for vehicle stops.
          <button 
            onClick={requestPermission} 
            style={{ 
              marginLeft: '15px', padding: '4px 12px', 
              cursor: 'pointer', color: '#000', 
              backgroundColor: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold' 
            }}
          >
            Enable
          </button>
        </div>
      )}

     <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/" element={<LoginPage />} />
        <Route path ="/trips" element={<Trips/>} />
        <Route path = "/vehicles" element ={<Vehicles/>} />
        <Route path = "/drivers" element ={<Drivers/>} />
        <Route path = "/earnings" element ={<Earnings/>} />
        <Route path = "/institutions" element ={<Institutions/>} />
        <Route path = "/devices" element ={<Devices/>} />
        <Route path = "/billing" element ={<Billing/>} />
        <Route path = "/reports" element ={<Reports/>} />
        <Route path = "/wv/documents" element ={<DocumentsScreen/>} />
        <Route path = "/wv/trips" element ={<TripsScreen/>} />
        <Route path = "/wv/offers" element ={<OffersScreen/>} />
        <Route path = "/wv/show_more" element ={<ShowMoreTrips/>} />
        <Route path = "/wv/orders" element ={<OrdersScreen/>} />
        <Route path="/wv/order-summary" element={<OrderSummaryScreen />} />
        <Route path = "/wv/routes" element ={<RoutesScreen/>} />
        <Route path = "/wv/register" element ={<RegisterScreen/>} />
        <Route path = "/wv/login" element ={<LoginScreen/>} />
        <Route path = "/wv/dashboard" element ={<DashboardScreen/>} />
        <Route path="/wv/route" element={<RoutePage />} />
        <Route path="wv/qr-payment" element={<QRCodePaymentScreen />} />
        <Route path="/wv/privacy_policy" element={<WebViewPrivacyPolicy />} />
        <Route path="/wv/terms_of_service" element={<WebViewTermsOfService />} />
        <Route path = "/company" element ={<Company/>} />
        <Route path = "/clients" element= {<ClientsPage/>}/>
        <Route path = "/vendors" element= {<VendorsPage/>}/>
        <Route path = "/warehouses" element= {<WarehousesPage/>}/>
        <Route path = "/users" element = {<UsersPage/>}/>
        <Route path = "/orders" element = {<OrdersPage/>}/>
        <Route path="/privacy_policy" element={<PrivacyPolicy />} />
        <Route path="/terms_of_service" element={<TermsOfService />} />
        <Route path="/trips/directions" element={<TripDirections />} />
        <Route path="/wv/parents" element={<ParentsPage />} />
        <Route path="/wv/stops" element={<StopsPage />} />
        <Route path="/stops" element={<Stops />} />
        {/* <Route path ="/parents" element = {<Parents/>}/> */}
        <Route path="/tickets" element={<TicketPage />} />
        <Route
          path="/offers"
          element={
            (() => {
              const userRole = storedUser ? storedUser?.role?.toLowerCase() : null;

              if (userRole === "platform_tech" || userRole === "platform_ops" || userRole === "platform_finance") {
                return <Offers />;
              } else if (userRole === "vendor_supervisor") {
                return <OffersScreen />;
              } else {
                return <OffersScreen />;
              }
            })()
          }
        />     
      </Routes>
       <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        style={{
          top: 'env(safe-area-inset-top, 20px)',
          right: 'env(safe-area-inset-right, 16px)',
          marginTop: '20px', 
          zIndex: 9999, 
        }}
      />
    </div>
  );
}
export default App;